<template>
    <nav class="navbar navbar-expand-lg navbar-light" id="mainNav">
        <div class="container px-4 px-lg-5">
            <router-link class="navbar-brand" to="/"><i class="fa-solid fa-house" />首页</router-link>
            <router-link class="navbar-brand" to="/homepage">{{ user }}</router-link>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive"
                aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                导航<i class="fa fa-caret-down" />
            </button>
            <div class="collapse navbar-collapse" id="navbarResponsive">
                <ul class="navbar-nav ms-auto py-4 py-lg-0">
                    <li class="nav-item" style="margin: auto">
                        <input class="search_bar" type="text" id="content" placeholder="想知道什么呢...?" />
                        <button onclick="toHtml()" class="search_button"><i class="fa fa-search" /></button>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link px-lg-3 py-3 py-lg-4" to="/chara_list"
                            style="font-size: 1.25rem"><i class="far fa-address-card" />角色</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link px-lg-3 py-3 py-lg-4" to="/relation_list"
                            style="font-size: 1.25rem"><i class="fa-solid fa-people-pulling" />关系</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link px-lg-3 py-3 py-lg-4" to="/closet_list/closet"
                            style="font-size: 1.25rem"><i class="fas fa-tshirt" />服设</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link px-lg-3 py-3 py-lg-4" to="/article_list"
                            style="font-size: 1.25rem"><i class="far fa-copy" />文档</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link px-lg-3 py-3 py-lg-4" to="/gallery_list"
                            style="font-size: 1.25rem"><i class="far fa-images" />图库</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link px-lg-3 py-3 py-lg-4" to="/contact" style="font-size: 1.25rem"><i
                                class="fa-regular fa-envelope" />联系</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link px-lg-3 py-3 py-lg-4" to="/log" style="font-size: 1.25rem"><i
                                class="fa-regular fa-calendar" />日志</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link px-lg-3 py-3 py-lg-4" to="/link" style="font-size: 1.25rem"><i
                                class="fa-regular fa-bookmark" />外站</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>
<script setup>
import { useStore } from 'vuex'
import { computed, onMounted } from 'vue'

const isAuthenticated = computed(() => {
    return store.state.isAuthenticated
})

const user = computed(() => {
    return store.state.user
})

function handleLogout() {
    store.dispatch('logout')
}

const store = useStore()

onMounted(() => {
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
        store.replaceState(
            Object.assign(
                {},
                store.state,
                JSON.parse(sessionStorage.getItem('store'))
            )
        )
    }

    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // beforeunload事件在页面刷新时先触发
    window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('store', JSON.stringify(store.state))
    })
})
</script>